module.exports = __webpack_public_path__ + "img/CookieOutlined.f27d86a4.svg";